<template>
  <v-list two-line class="pa-0">
    <v-list-item-group>
      <div v-for="(item, index) in items" :key="index">
        <view-training-material-list-item class="course-additional" :item="item" />
        <v-divider v-if="index + 1 < item.length" :key="index"></v-divider>
      </div>
    </v-list-item-group>
  </v-list>
</template>
<script>
import ViewTrainingMaterialListItem from "@/pages/authenticated/courses/ViewTrainingMaterialListItem";

export default {
  name: "ViewSupplementalDocumentation",
  components: {
    ViewTrainingMaterialListItem
  },
  data: () => ({
    selected: false
  }),
  computed: {
    items: function() {
      return this.$store.getters.coursePlayer.assets.data;
    },
    course: function() {
      return this.$store.getters.coursePlayer;
    },
  }
};
</script>